export default "__VITE_ASSET__J9cFU$b4__"